import { redirectAutoLogout, removeAuthToken } from '@/lib/api/authToken'
import { logoutThunk } from '@/redux/slices/sessionSlice'
import { useAppDispatch } from '@/redux/store'
import { useCallback, useEffect } from 'react'
import { Platform } from 'react-native'
import Alert from '@/components/Alert'

type LogoutAlertProps = {
  open: boolean
  setOpen: (open: boolean) => void
}

export default function LogoutAlert({ open, setOpen }: LogoutAlertProps) {
  const dispatch = useAppDispatch()

  const handleLogout = useCallback(async () => {
    if (Platform.OS === 'web') {
      removeAuthToken()
      redirectAutoLogout()
      return
    }
    await dispatch(logoutThunk())
  }, [dispatch])

  useEffect(() => {
    if (open) {
      Alert.alert('确定要退出此账号吗？', undefined, [
        { text: '取消', style: 'cancel', onPress: () => setOpen(false) },
        { text: '退出登录', style: 'destructive', onPress: handleLogout },
      ])
    }
  }, [open, setOpen, handleLogout])

  return null
}
